module.exports = __webpack_public_path__ + "img/penticostar-1743-pagina-de-titlu-big.47ea2784.jpg";